import { useState } from 'react';

import { Header } from '../Analysis/Header';
import { getUserProfile } from '~/helpers/userProfile';

export const ClientPanelLayout = (): JSX.Element => {
  const [profile] = useState(getUserProfile);
  const links: {
    link: string,
    title: string,
    prefix?: string
  }[] = [
    {
      link: '/painel/client-painel',
      title: 'Painel',
    },
  ];

  if ((!profile.manageAllClients) && (profile.manageSomeClient) && !profile.permissions.isInstaller && profile.permissions.CLIENT_MANAGE.includes(145)) {
    links.push({
      link: '/painel/projeto-bb/kpis',
      prefix: '/painel/projeto-bb/',
      title: 'Informações do Projeto',
    });
  }

  return (
    <Header links={links} />
  );
};
